var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2539 7.388L19.0419 4.176C18.9185 4.04986 18.7599 3.96397 18.5868 3.9296C18.4137 3.89523 18.2344 3.91399 18.0721 3.98342C17.9099 4.05285 17.7725 4.16971 17.6779 4.31865C17.5832 4.46759 17.5358 4.64165 17.5419 4.818C17.5487 5.05442 17.637 5.28121 17.7919 5.46L19.4689 7.137H16.0779V0H0.731934V16.061H16.0789V8.923H19.4698L17.7919 10.6C17.6516 10.7746 17.5815 10.9953 17.5952 11.2189C17.609 11.4425 17.7056 11.6529 17.8662 11.8091C18.0268 11.9652 18.24 12.0558 18.4639 12.0632C18.6878 12.0706 18.9063 11.9942 19.0769 11.849L22.2889 8.637C22.3726 8.553 22.4379 8.45261 22.481 8.34213C22.524 8.23165 22.5438 8.11346 22.5389 7.995C22.5371 7.87942 22.5107 7.76555 22.4615 7.66091C22.4124 7.55628 22.3417 7.46326 22.2539 7.388ZM14.3309 10.888V14.279H2.55188V1.785H14.3319V7.139H10.2319C9.99523 7.139 9.76821 7.23303 9.60083 7.40041C9.43345 7.56778 9.33936 7.79479 9.33936 8.0315C9.33936 8.26821 9.43345 8.49522 9.60083 8.66259C9.76821 8.82997 9.99523 8.924 10.2319 8.924H14.3319L14.3309 10.888Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.3f776fd3f8070bc021e081d7f9b1609d.svg";
export { ForwardRef as ReactComponent };